<template>
    <el-form
            class="mam-master-settting"
            ref="editform"
            :model="editForm"
            :rules="rules"
    >
        <el-form-item>
            <p class="self-label lable12_bold">
                {{$t('Is_it_public')}}
                <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                        <p>{{$t('mamMasterOpenLimitTips')}}</p>
                    </div>
                    <i class="el-icon-info tips-icon"></i>
                </el-tooltip>
            </p>
            <el-switch
                    v-model="editForm.isOpen"
                    active-color="#13ce66"
                    inactive-color="#cccccc"></el-switch>
        </el-form-item>
        <transition name="commom">
            <el-form-item
                    v-if="editForm.isOpen"
            >
                <p class="self-label">{{$t('Strategy_description')}}</p>
                <el-input
                        type="textarea"
                        v-model="editForm.strategy"
                        maxlength="150"
                        :row="4"
                        resize="none"
                        show-word-limit
                ></el-input>
            </el-form-item>
        </transition>
        <el-row
                v-if="editForm.isOpen"
                :gutter="20">
            <el-col :span="24">
                <el-form-item prop="limit">
                    <p class="self-label">{{$t('Follower_funding_limit')}}</p>
                    <div class="input-prefix-outer pr limit">
                        <div class="span prefix pa">USD</div>
                        <el-input
                                class="input-prefix-ele"
                                :placeholder="phFileter($t('Unlimited'), self)"
                                :value="editForm.limit"
                                @input="limitInputHandle"
                        ></el-input>
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item
                        prop="copyPassword"
                >
                    <p class="self-label">{{$t('Subscription_password')}}</p>
                    <el-input
                            :placeholder="phFileter($t('digit6_combination_of_numbers_and_letters'), self)"
                            v-model="editForm.copyPassword"
                    ></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <transition name="common">
            <el-form-item
                v-if="editForm.isOpen"
            >
                <p class="self-label lable12_bold">{{$t('charge')}}
                    <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content" style="width: 400px;">
                            <p
                                v-for="(item,index) in $t('mamSettingChargeNewTips')"
                                :key="index"
                            >{{item}}</p>
                        </div>
                        <i class="iconfont iconshuoming tips-icon"></i>
                    </el-tooltip>
                </p>
                <el-switch
                        v-model="editForm.isCharge"
                        active-color="#13ce66"
                        inactive-color="#cccccc"
                ></el-switch>
            </el-form-item>
        </transition>
        <transition name="common">
            <el-form-item
                    prop="managementFee"
                    v-if="costFormItemFlag"
            >
                <p class="self-label">{{$t('management_fee')}}</p>
                <div class="management-fee-outer pr">
                    <el-input :placeholder="phFileter($t('Please_enter_the_management_fee_ratio'),self)" v-model.number="editForm.managementFee"></el-input>
                    <div class="suffix pa">%</div>
                </div>
            </el-form-item>
        </transition>
        <transition name="common">
          <p
            v-if="costFormItemFlag"
            class="self-label">{{$t('Performance_fee')}}</p>
        </transition>
        <transition-group name="common">
            <template v-if="costFormItemFlag">
                <el-form-item
                        class="profit-money-form-item"
                        v-for="(item,index) in editForm.sharePrice"
                        :key="index"
                        :prop="'sharePrice.' + index + '.shareValue'"
                        :rules="{
                            validator: validateFloorVm, trigger: 'blur'
                        }"
                >
                    <div class="add-btn-outer">
                        <div class="input-prefix-outer">
                            <el-input
                                    class="input-prefix-ele"
                                    :placeholder="phFileter($t('Please_enter_the_share_ratio'),self)"
                                    v-model.number="item.shareValue"
                            >
                                <el-select
                                        v-model="item.profitValue"
                                        slot="prepend"
                                        :placeholder="phFileter($t('root.selectPls'),self)"
                                        @change="selectChangeHandle"
                                >
                                    <el-option
                                            v-for="(innerItem, optionIndex) in item.selectList"
                                            :key="optionIndex"
                                            :label="`${$t('profit')}≥${innerItem.label}%`"
                                            :value="innerItem.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-input>
                            <div class="suffix pa">%</div>
                        </div>
                        <div class="btn-box">
                            <i
                                    v-if="index == 0"
                                    class="theme-font fs20 el-icon-plus add-btn"
                                    :class="{hide: editForm.sharePrice.length >= 5}"
                                    @click="addHandle(index)"
                            ></i>
                            <i
                                    v-if="index !== 0 "
                                    class="theme-font fs20 el-icon-minus"
                                    @click="deleteHandle(index)"
                            ></i>
                        </div>
                    </div>
                </el-form-item>
            </template>
        </transition-group>
    </el-form>
</template>

<script>
  //  [{value: 1,label: 1,},{value: 5,label: 5,},{value: 10,label: 10,},{value: 20,label: 20,},{value: 40,label: 40,},{value: 50,label: 50,},{value: 60,label: 60,},{value: 80,label: 80,},{value: 100,label: 100,},]
    // sharePrice:[
    // {
    //      shareValue: 1, profitValue: 0.1,
    //      proportionPrefixList:[]
    // },
    // {
    //      shareValue: 5, profitValue: 0.1,
    //      proportionPrefixList:[]
    // }
    // ]
  import { phFileter, getSelectList, getProportionPrefixList } from '@/utils/common'
  import { dealPassFisrtStrong, handReg, NOmoreThanTwoDecimal,noZeroInit,amountInputValidate } from '@/utils/validate'
  export default {
    name: 'mamMasterSetting',
    props: {
      nickName:{
        type: String,
        default: '',
      },
      businessType:{
        default: '',
      },
      formData: {
        type: Object,
        default(){
          return {
            isOpen: false,
            strategy: '',
            limit: '',
            copyPassword: '',
            isCharge: false,
            managementFee: '',
            sharePrice:[
              {
                shareValue: '',
                profitValue: '',
                selectList: getProportionPrefixList()
              }
            ]
          }
        }
      }
    },
    data() {
      let _this = this;
      let validateCopyLimit = (rule, value, callback) => {
        if(value === ''){
          callback()
        }else {
          if(!noZeroInit(value)){
            callback(new Error(_this.$t('integerTips')))
          }else {
            callback()
          }
        }
      };
      let validateCopyPassword = (rule, value, callback) => {
        if(value === ''){
          callback()
        }else {
          if(!dealPassFisrtStrong(value)){
            callback(new Error(_this.$t('digit6_combination_of_numbers_and_letters')))
          }else {
            callback()
          }
        }
      };
      let validateManagementFee = (rule, value, callback) => {
        if(value === ''){
          callback(new Error(_this.$t('Please_enter_an_integer_less_than_100')));
        }else {
          if(value < 0 || value > 100){
            callback(new Error(_this.$t('Please_enter_an_integer_less_than_100')))
          }else {
            callback()
          }
        }
      };

      return {
        editForm: {
          isOpen: false,
          limit: '',
          copyPassword: '',
          isCharge: false,
          managementFee: '',
          sharePrice: [
            {
              shareValue: '',
              profitValue: '',
            }
          ]
        },
        rules:{
          limit:[
            {validator: validateCopyLimit, trigger: 'blur'}
          ],
          copyPassword:[
            {validator: validateCopyPassword, trigger: 'blur'}
          ],
          managementFee:[
            {validator: validateManagementFee, trigger: 'blur'}
          ],
          // profitValue:[
          //   {validator: validateFloor, trigger: 'blur'}
          // ],
        },
        self: {},
      };
    },
    created(){
      this.self = this;
      this.editForm = JSON.parse(JSON.stringify(this.formData));
    },
    watch:{
      formData:{
        handler(newValue){
            this.editForm = JSON.parse(JSON.stringify(newValue));
        },
        deep: true,
      },
    },
    computed: {
      costFormItemFlag(){
        return this.editForm.isOpen && this.editForm.isCharge;
      },
    },
    methods: {
      phFileter,
      limitInputHandle(val){
        this.editForm.limit = amountInputValidate(val);
      },
      validate(){
        this.$refs.editform.validate((valid) => {
          if(valid){
            if(this.editForm.isCharge){
              //
              let isEveryFloorZero = this.editForm.sharePrice.every((element,index, array) => {
                return element.shareValue === 0;
              });
              if((!this.editForm.managementFee || this.editForm.managementFee == 0) /*&& 表现费的每一层都不能为0*/ && isEveryFloorZero){
                this.$message({
                  type: 'warning',
                  message: this.$t('Fill_in_at_least_one_charging_rule')
                });
              }else {
                // submit ajax
                let isEveryFloorSelectNull = this.editForm.sharePrice.some((element,index, array) => {
                  return element.profitValue === '';
                });
                if(isEveryFloorSelectNull){
                  this.$message({
                    type: 'warning',
                    message: this.$t('Please_select_the_share_proportion')
                  });
                }else {
                  console.log('pass validate');
                  this.$emit('send-form', this.editForm);
                }
              }
            }else {
              this.$emit('send-form', this.editForm);
              console.log('pass validate');
            }
          }else {
            console.log('error');
          }
        })
      },
      getLabel(item,prefxx){
        return prefxx + item.label;
      },
      addHandle(index){
        if(this.editForm.sharePrice.length >= 5) return;
        let selectList = getSelectList(this.editForm.sharePrice);
        this.editForm.sharePrice.push({
          shareValue: '',
          profitValue: '',
          selectList: selectList
        });
      },
      deleteHandle(index){
        this.editForm.sharePrice.splice(index, 1);
        this.selectChangeHandle();
      },
      selectChangeHandle(){
        for (let i = this.editForm.sharePrice.length - 1; i >= 0 ; i--) {
          this.editForm.sharePrice[i].selectList = getSelectList(this.editForm.sharePrice, i);
        }
      },
      validateFloorVm(rule, value, callback){
        if(value === '' || value === null){
          callback(new Error(this.$t('Please_enter_an_integer_less_than_100')));
        }else {
          if(value < 0 || value > 100){
            callback(new Error(this.$t('Please_enter_an_integer_less_than_100')));
          }else {
            callback()
          }
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
.mam-master-settting {
    .tips-icon {
        color: #cccccc;
    }

    .input-prefix-outer {
        width: 100%;
        .prefix {
            left: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: #333333;
            z-index: 99;
        }
        &.limit {
            /deep/ .input-prefix-ele .el-input__inner{
                padding-left: 50px;
            }
        }
    }
    .add-btn-outer {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .btn-box {
            margin-left: 10px;
            cursor: pointer;
        }
        .suffix {
            right: 45px;
        }
        /deep/ .el-select .el-input {
            width: 130px;
        }
        /deep/ .el-input-group__prepend {
            background-color: #fff;
        }
        .add-btn {
            &.hide {
                visibility: hidden;
            }
        }
    }
    .profit-money-form-item {
        /deep/ .el-form-item__error {
            left: 130px;
        }
    }
}
</style>
